<template>
  <HttpContentView :endpoint="utilities.path('users/communities/invites/@', token)">
    <template v-slot:content="{ data: invite }">
      <div class="d-flex justify-content-center text-center align-items-center h-100">
        <div class="card" style="max-width: 400px">
          <div class="card-body">
            <div class="d-flex flex-column g-5">
              <div class="text-center">
                <img v-if="invite.community.logoUrl" :src="invite.community.logoUrl" height="90" class="mb-4"/>
                <h1 class="mb-0">{{ invite.community.name }}</h1>
              </div>
              <div>
                {{ translate("communities.invite.description") }}
              </div>
              <HttpFormView :endpoint="utilities.path('users/communities/invites/@/accept', token)" method="post" @success="router.push({ name: 'user.me.communities' })">
                <template v-slot:form="{ submit, loading }">
                  <ButtonView type="normal" color="primary" class="w-100" @click="submit">
                    {{ translate("accept") }}
                  </ButtonView>
                  <SpinnerView color="primary" :active="loading"/>
                </template>
              </HttpFormView>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:error="{ status }">
      <div v-if="status === 404" class="d-flex justify-content-center align-items-center h-100">
        <div class="text-center" style="max-width: 300px; margin: auto auto">
          <i class="fa-duotone fa-question-circle text-info" style="font-size: 5em"></i>
          <div class="mt-5">{{ translate("communities.invite.not.found") }}</div>
        </div>
      </div>
      <div v-else-if="status === 403" class="d-flex justify-content-center align-items-center h-100">
        <div class="text-center" style="max-width: 300px; margin: auto auto">
          <i class="fa-duotone fa-ban text-warning" style="font-size: 5em"></i>
          <div class="mt-5">{{ translate("communities.invite.forbidden") }}</div>
        </div>
      </div>
    </template>
  </HttpContentView>
</template>

<script setup>
import {ButtonView, HttpContentView, SpinnerView, utilities, HttpFormView} from "@/niftybit";
import {useRouter} from "vue-router";

defineProps({
  token: String
});

const router = useRouter();

</script>